import { t } from "@dovach/i18n";

/**
 * Rendered when WebCrypto / WebAssembly is missing — a real Hebrew page with one
 * suggested action, never a white screen.
 */
export function BrowserUnsupported() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center px-6 text-center">
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-8 dark:border-amber-700/40 dark:bg-amber-900/20">
        <p className="text-2xl font-semibold text-amber-900 dark:text-amber-100">
          {t("client_web.browser_unsupported_title")}
        </p>
        <p className="mt-3 text-base text-amber-800 dark:text-amber-200">
          {t("client_web.browser_unsupported_body")}
        </p>
      </div>
    </div>
  );
}
